
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  subnav: true,
  maxTocLevel: 4,
  layout: 'reference',
  secondLevelToc: true,
  alwaysExpand: true,
  parentTocLevel: 3,
  childTocLevel: 4,
  description: 'API reference for endpoints and webhooks associated with the Plaid Liabilities product.',
  source: 'endpoint'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Schema = makeShortcode("Schema");
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Liabilities' subtitle='API reference for Liabilities endpoints and webhooks' compact mdxType="Header" />
    <p>{`For how-to guidance, see the `}<a parentName="p" {...{
        "href": "/docs/liabilities/"
      }}>{`Liabilities documentation`}</a>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Endpoints`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/liabilities/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch liabilities data`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Webhooks`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#default_update"
            }}><inlineCode parentName="a">{`DEFAULT_UPDATE`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New or updated liabilities available`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "endpoints"
    }}>{`Endpoints`}</h3>
    <h4 {...{
      "id": "liabilitiesget"
    }}>{`/liabilities/get`}</h4>
    <Schema method='POST' route='/liabilities/get' type='request' mdxType="Schema">
      <MDXCodeBlock title='/liabilities/get' type='server' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/liabilities/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "access_token": String
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`// Retrieve Liabilities data for an Item
const request: LiabilitiesGetRequest = {
  access_token: accessToken,
};
try {
  const response = await plaidClient.liabilitiesGet(request);
  const liabilities = response.data.liabilities;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`# retrieve Liabilities data for an item
request = LiabilitiesGetRequest(access_token=access_token)
response = client.liabilities_get(request)
liabilities = response['liabilities']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`// Retrieve Liabilities data for an Item
LiabilitiesGetRequest request = new LiabilitiesGetRequest()
  .accessToken(accessToken);
Response<LiabilitiesGetResponse> response = client()
  .liabilitiesGet(request)
  .execute();
LiabilitiesObject liabilities = response.body().getLiabilities();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`# retrieve Liabilities data for an item
request = Plaid::LiabilitiesGetRequest.new({ access_token: access_token })
response = client.liabilities_get(request)
liabilities = response.liabilities
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewLiabilitiesGetRequest(accessToken)
resp, _, err := client.PlaidApi.LiabilitiesGet(ctx).LiabilitiesGetRequest(*request).Execute()
liabilities := resp.GetLiabilities()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.LiabilitiesGetRequest{AccessToken: accessToken}
resp, err := client.Liabilities.Get(ctx, request)
liabilities := resp.GetLiabilities()
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/liabilities/get' type='response' mdxType="Schema" />
    <h3 {...{
      "id": "webhooks"
    }}>{`Webhooks`}</h3>
    <p>{`Liabilities webhooks are sent to indicate that new loans or updated loan fields
for existing accounts are available.`}</p>
    <h4 {...{
      "id": "default_update"
    }}><inlineCode parentName="h4">{`DEFAULT_UPDATE`}</inlineCode></h4>
    <Schema model='LiabilitiesDefaultUpdateWebhook' type='model' mdxType="Schema" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "endpoints",
        level: 3,
        title: "Endpoints",
      },
{
        id: "liabilitiesget",
        level: 4,
        title: "/liabilities/get",
      },
{
        id: "webhooks",
        level: 3,
        title: "Webhooks",
      },
{
        id: "default_update",
        level: 4,
        title: "DEFAULT_UPDATE",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
